module.exports = __webpack_public_path__ + "img/text-indent-left.cfdc64af.svg";